export function SpinnerWeb() {
  return (
    <div data-testid="spinner-web" className="flex w-full flex-col items-center justify-center">
      <div
        style={{ borderTopColor: 'transparent' }}
        className="border-dtkGold-100 h-14 w-14 animate-spin rounded-full border-4 border-solid"
      />
    </div>
  );
}
